// One side offers; retry without discarding working tracks or privacy processing.
export function attachCallRecovery(pc,{isOfferer,isCurrent,isOnline,sendOffer,onStatus,onExhausted=()=>{},timeoutMs=120000}) {
 let stopped=false,busy=false,timer,deadlineTimer,attempts=0,lastAttempt=0,pendingOfferSince=null;
 let restartRequired=false,restartRemote; 
 const connected=()=>!['failed','disconnected','closed'].includes(pc.connectionState)&&!['failed','disconnected','closed'].includes(pc.iceConnectionState)&&(pc.connectionState==='connected'||['connected','completed'].includes(pc.iceConnectionState));
 const recovered=()=>connected()&&(!restartRequired||(pc.signalingState==='stable'&&pc.remoteDescription!==restartRemote));
 const clearDeadline=()=>{clearTimeout(deadlineTimer);deadlineTimer=undefined;};
 const startDeadline=()=>{
  if(deadlineTimer!==undefined)return;
  deadlineTimer=setTimeout(()=>{
   if(stopped||!isCurrent())return;
   if(recovered()){clearDeadline();restartRequired=false;onStatus('');return;}
   stopped=true;clearTimeout(timer);
   onStatus("לא הצלחנו לחבר את השיחה מחדש. נסו להתקשר שוב.");
   onExhausted();
  },timeoutMs);
 };
 const schedule=(delay=4000)=>{clearTimeout(timer);if(!stopped)timer=setTimeout(()=>recover(),delay);};
 async function recover(force=false){
  if(stopped||!isCurrent()||pc.signalingState==='closed')return;
  // A refreshed peer can need a new offer while our old transport still looks connected.
  if(force&&isOfferer&&connected()&&!restartRequired){restartRequired=true;restartRemote=pc.remoteDescription;}
  if(!force&&recovered()){clearDeadline();restartRequired=false;attempts=0;onStatus('');return;}
  startDeadline();onStatus("מתחברים מחדש לשיחה…");
  if(!isOfferer||!isOnline()||busy){schedule();return;}
  // Repeated peer notifications must not tear down an offer awaiting its answer.
  // This also protects the initial offer, which is created outside this helper.
  if(pc.signalingState==='have-local-offer'){
   if(pendingOfferSince===null)pendingOfferSince=Date.now();
   if(Date.now()-pendingOfferSince<8000){schedule();return;}
  }else pendingOfferSince=null;
  if(lastAttempt && Date.now()-lastAttempt<8000){schedule();return;}
  busy=true;lastAttempt=Date.now();
  try {
   if(pc.signalingState==='have-local-offer')await pc.setLocalDescription({type:'rollback'});
   if(pc.signalingState!=='stable'){schedule();return;}
   const offer=await pc.createOffer({iceRestart:true});
   if(stopped||!isCurrent())return;
   await pc.setLocalDescription(offer);
   pendingOfferSince=Date.now();
   if(!stopped&&isCurrent())sendOffer(pc.localDescription);
  }catch{}finally{busy=false;if(!stopped)schedule(Math.min(15000,3000*++attempts));}
 }
 function state(){
  if(stopped||!isCurrent())return;
  if(recovered()){restartRequired=false;clearTimeout(timer);clearDeadline();attempts=0;pendingOfferSince=null;lastAttempt=0;onStatus('');}
  else if(['failed','disconnected'].includes(pc.connectionState)||['failed','disconnected'].includes(pc.iceConnectionState))schedule(pc.connectionState==='failed'?500:3000);
 }
 pc.onconnectionstatechange=state;pc.oniceconnectionstatechange=state;
 schedule(8000);
 return {recover,stop(){stopped=true;clearTimeout(timer);clearDeadline();}};
}
